import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { UiAccessibilityModule } from "../accessibility/accessibility.module";
import { UiCoreModule } from "../core/core.module";
import { UiIconModule } from "../icon/icon.module";
import { UiTooltipModule } from "../tooltip/tooltip.module";
import { UiAvatarComponent } from "./avatar.component";
import { UiBadgeAvatarComponent } from "./components/badge-avatar/badge-avatar.component";

@NgModule({
  imports: [CommonModule, UiIconModule, UiCoreModule, UiTooltipModule, UiAccessibilityModule],
  declarations: [UiAvatarComponent, UiBadgeAvatarComponent],
  exports: [UiAvatarComponent, UiBadgeAvatarComponent],
})
export class UiAvatarModule {}
